export default __webpack_public_path__ + "static/media/qr-code.7c583a69.svg";